import * as React from 'react'
import g from 'glamorous'
import * as moment from 'moment'

import { MyDebtsQueryResult, Loan } from '../../components/queries/MyDebtsQuery'
import ToPayOverlay from '../../components/ToPayOverlay'
import { loan as commons } from '../../components/DatagridCommons'
import { Datagrid, IDefinition } from '../../components/Datagrid'
import { moneyFormat } from '../../utils/format'

type UserDebtsTableProps = {
  debts: MyDebtsQueryResult['user']['debts']
}

const TrNoHover = g.tr(() => ({
  border: '1px solid white',
  ':hover': {
    backgroundColor: 'white !important'
  }
}))

const definition: IDefinition<Loan> = {
  columns: [
    commons.columns.date,
    commons.columns.creditor,
    commons.columns.interval,
    commons.columns.description,
    commons.columns.interest,
    commons.columns.loanedAmount,
    commons.columns.toPay,
    commons.columns.detailAction
  ],
  idGetter: data => data.id,
  defaultSort: 'date'
}

const UserDebtsTable: React.SFC<UserDebtsTableProps> = ({ debts }) => (
  <Datagrid definition={definition} data={debts}>
    {(data) => (
      <TrNoHover>
        <td colSpan={5} style={{ border: '0px' }} />
        <td style={{ border: '0px', textAlign: 'right' }}>
          Celk. jistina:{' '}
          {moneyFormat(
            data.reduce((sum, loan) => sum + (loan.state.loanedAmount || 0), 0)
          )}
        </td>
        <td style={{ border: '0px', textAlign: 'right' }}>
          <ToPayOverlay label="Celk. dluh" loans={data} date={moment()} />
        </td>
        <td style={{ border: '0px' }} />
      </TrNoHover>
    )}
  </Datagrid>
)

export default UserDebtsTable



// WEBPACK FOOTER //
// ./src/screens/dashboard/UserDebtsTable.tsx